/**
 * Fire screenshot capture routes after the page has painted (non-blocking).
 * Each URL should return quickly; the server runs capture after the HTTP response.
 */
export function queueScreenshotCaptures(urls) {
  const list = Array.isArray(urls) ? urls.filter(Boolean) : []
  if (list.length === 0) {
    return
  }

  let index = 0

  const runNext = () => {
    if (index >= list.length) {
      return
    }

    const url = list[index]
    index += 1

    fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    }).catch(() => {}).finally(() => {
      window.setTimeout(runNext, 500)
    })
  }

  const start = () => window.setTimeout(runNext, 250)

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(start, { timeout: 3000 })
  } else {
    start()
  }
}
